import { render, staticRenderFns } from "./ListagemDeOrgaosPorItem.vue?vue&type=template&id=26c3a337"
import script from "./ListagemDeOrgaosPorItem.vue?vue&type=script&lang=js"
export * from "./ListagemDeOrgaosPorItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports